// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useNavigate } from 'react-router-dom';
import { useRoutines, useMaintenanceTasks } from '../../hooks/useAlarms';
import { PageHead, SevTag, EmptyState, Loading, DxTag } from '../../components/shell/ScreenHelpers';

export default function DailyCompliance() {
  const navigate = useNavigate();
  const { routines, loading: routinesLoading } = useRoutines();
  const { tasks, loading: tasksLoading } = useMaintenanceTasks();

  const loading = routinesLoading || tasksLoading;
  const isEmpty = routines.length === 0 && tasks.length === 0;

  return (
    <div className="hs-page">
      <PageHead
        title="Daily / Compliance"
        dateline="Routines & scheduled maintenance · GA-10 Atlanta"
      />

      {loading ? (
        <Loading />
      ) : isEmpty ? (
        <EmptyState big="Nothing scheduled." />
      ) : (
        <>
          {routines.length > 0 && (
            <>
              <div className="helios-subnav-title" style={{ padding: '0 0 8px' }}>
                Routines
              </div>
              <div className="hs-tiles">
                {routines.map(r => {
                  const inner = (
                    <>
                      <div className="hs-card-row">
                        <span className="hs-card-asset">{r.name}</span>
                        {r.running && (
                          <span
                            aria-label="Running"
                            title="Running"
                            style={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              background: 'var(--st-ok)',
                            }}
                          />
                        )}
                        {r.escalated && r.alarmRef && <DxTag>Escalated → {r.alarmRef}</DxTag>}
                      </div>
                      <div className="hs-card-meta">
                        <span>{r.cadence}</span>
                        <span>last {r.last}</span>
                        <span>{r.runs} runs</span>
                      </div>
                      <div className="hs-card-summary">{r.result}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-helper)' }}>{r.detail}</div>
                    </>
                  );

                  return r.escalated && r.alarmRef ? (
                    <button
                      key={r.id}
                      type="button"
                      className="hs-card"
                      style={{ borderLeftColor: 'var(--sev4)' }}
                      onClick={() => navigate(`/alarms/${r.alarmRef}`)}
                    >
                      {inner}
                    </button>
                  ) : (
                    <div key={r.id} className="hs-card" style={{ cursor: 'default' }}>
                      {inner}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {tasks.length > 0 && (
            <>
              <div className="helios-subnav-title" style={{ padding: '24px 0 8px' }}>
                Maintenance
              </div>
              <div className="hs-tiles">
                {tasks.map(t => (
                  <div key={t.id} className="hs-card" style={{ cursor: 'default' }}>
                    <div className="hs-card-row">
                      {t.sev && <SevTag sev={t.sev} />}
                      <span className="hs-diag-tag">Maintenance</span>
                    </div>
                    <div className="hs-card-meta">
                      <span>{t.dueLabel}</span>
                    </div>
                    <div className="hs-card-asset">{t.title}</div>
                    <div className="hs-card-meta">
                      <span>{t.asset}</span>
                      <span>{t.location}</span>
                      {t.time && <span>{t.time}</span>}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
